const head = $('header').css('padding-left')
const heading = $('.first__heading');

if ($(window).width() > 970) {
    heading.css('right', parseInt(head) + 10 + "px")
}



